export type ColorBand = "red" | "orange" | "green";

export function colorBandFor(ratio: number): ColorBand {
  return ratio < 0.5 ? "red" : ratio < 1.0 ? "orange" : "green";
}
